<template>
    <v-dialog v-model="editorShownSickness" width="850" persistent>
        <!-- Begin:Content:Mode:update ------------------------------------- -->
        <v-card v-if="editorMode === 'update'" style="border: 2px solid gray;">
            <v-card-title class="blue-grey lighten-1 pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: #ffffff;" class="b-fa b-fa-briefcase-medicalrn"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} - Multiple ({{ editorMode.toUpperCase() }})
            </v-card-title>
            <!-- Selected Sickness List ------------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px; margin-bottom: 0px;"><i style="font-size:15px; color: red; padding-right: 10px;" class="b-fa b-fa-user"></i><strong>Choose your Employees/Sickness:</strong></div>
            <selected-sickness-list v-model="employees" v-if="editorShownSickness" />

            <v-divider style="margin-top: 20px;"></v-divider>

           <!-- Selecting Sickness ----------------------------------------- -->
            <v-card-text class="pa-5">
                <datetime v-model="startDate" label="Sickness - from:" disabled="false" disabledTime="true" ref="startTimer" />
                <datetime v-model="endDate" label="Sickness  - to:" disabled="true" disabledTime="true" ref="endTimer" />

                <v-row>
                    <v-col cols="6" class="">
                        <yesno-combo v-model="certificate" label="Select - CERTIFICATE:" />
                    </v-col>

                    <v-col cols="6" class="">
                        <yesno-combo v-model="fit" label="Select - FIT:" />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="6" class="">
                        <yesno-combo v-model="sickOnTour" label="Select - SICKONTOUR:" />
                    </v-col>

                    <v-col cols="6" class="">
                        <yesno-combo v-model="sickChild" label="Select - SICKCHILD:" />
                    </v-col>
                </v-row>

            </v-card-text>

            <v-card-text class="pa-5">
                <comment-textarea v-model="dutyComment" label="Sickness Comment:" maxlength="300" />
            </v-card-text>

            <v-divider></v-divider>

            <!-- Card Actions ---------------------------------------------- -->
            <v-card-actions>
                <span style="font-size: 12px; font-weight: 700; color: #606263; padding-left: 25px;"><strong>Status: {{ get_selectedMultiEvents('SICKNESS').length }} Sicknesse(s) in Scheduler selected</strong></span>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onClose_SicknessDialog">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_SicknessUpdate"> Save</v-btn>
            </v-card-actions>
        </v-card>



        <!-- Begin:Content:Mode:create ------------------------------------- -->
        <v-card v-if="editorMode === 'create'" style="border: 2px solid gray;">
            <v-card-title class="blue-grey lighten-1 pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: #ffffff;" class="b-fa b-fa-briefcase-medical"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} - Multiple ({{ editorMode.toUpperCase() }})
            </v-card-title>

            <!-- Selected Employees List ----------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px; margin-bottom: 0px;"><i style="font-size:15px; color: red; padding-right: 10px;" class="b-fa b-fa-user"></i><strong>Choose your Employees:</strong></div>
            <selected-employees-list v-model="employees" v-if="editorShownSickness" />

            <v-divider style="margin-top: 0px;"></v-divider>

            <!-- Selecting Standby ----------------------------------------- -->
            <v-card-text class="pa-5">
                <datetime v-model="startDate" label="Sickness - from:" disabled="false" disabledTime="true" ref="startTimer" />
                <datetime v-model="endDate" label="Sickness  - to:" disabled="false" disabledTime="true" ref="endTimer" />

                <v-row>
                    <v-col cols="6" class="">
                        <yesno-combo v-model="certificate" label="Select - CERTIFICATE:" />
                    </v-col>

                    <v-col cols="6" class="">
                        <yesno-combo v-model="fit" label="Select - FIT:" />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="6" class="">
                        <yesno-combo v-model="sickOnTour" label="Select - SICKONTOUR:" />
                    </v-col>

                    <v-col cols="6" class="">
                        <yesno-combo v-model="sickChild" label="Select - SICKCHILD:" />
                    </v-col>
                </v-row>

            </v-card-text>

            <v-card-text class="pa-5">
                <comment-textarea v-model="dutyComment" label="Sickness Comment:" maxlength="300" />
            </v-card-text>

            <v-divider></v-divider>

            <!-- Card Actions ---------------------------------------------- -->
            <v-card-actions>
                <span style="font-size: 12px; font-weight: 700; color: #606263; padding-left: 25px;"><strong>Status: {{ get_selectedMultiResources.length }} Employee(s) in Scheduler selected</strong></span>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onClose_SicknessDialog">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_SicknessCreate"> Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import Vue from 'vue';
    import Datetime from '../../DateTime.vue';
    import YesnoCombo from '../../YesnoCombo.vue';
    import CommentTextarea from '../../CommentTextarea.vue';
    import SelectedSicknessList from '../../SelectedSicknessList.vue';
    import SelectedEmployeesList from '../../SelectedEmployeesList.vue';

    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../../../../../main';
    import moment from 'moment';


    export default {
        name  : 'event-editor-sickness',

        /* >>> *************************************************************** / /* Props */
        props : {

            value           : [ Boolean, Object ],                              // editorShownSickness
            eventStore      : Object,                                           // 'update'
            resourceId      : [ String, Number ],                               // 'update'
            eventRecord     : Object,                                           // 'update'
            resourceRecord  : Object,                                           // 'create'
            addDate         : Date,                                             // 'create'
            eventName       : String,                                           // 'update', 'create'
            editorMode      : String,                                           // 'update', 'create'

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components : {

            Datetime,
            YesnoCombo,
            CommentTextarea,
            SelectedSicknessList,
            SelectedEmployeesList,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            // >>> ------------------------------
            startDate       : null,
            endDate         : null,
            // >>> ------------------------------
            certificate     : null,
            fit             : null,
            sickOnTour      : null,
            sickChild       : null,
            // >>> ------------------------------
            dutyComment     : null,
            employees       : [],
            // >>> ------------------------------

        }), // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_selectedMultiResources',
                'get_selectedMultiEvents',
                'get_shared_IsEditingInThePastAllowed'
            ]),


            /*******************************************************************
            * editorShownSickness()
            *
            * Desc:
            * Note: Distinguishes between editorMode: 'update', 'create'
            *
            */
            editorShownSickness: {

                /***************************************************************
                * get()
                *
                * Note: Distinguishes between editorMode: 'update', 'create'
                * Note: Set '23:59' to Create endDate.
                *
                */
                get() {

                    let me = this,
                        timestamp = null,
                        startDate = null,
                        endDate = null,
                        resourceRecord = me.resourceRecord,
                        eventRecord = me.eventRecord;;


                    me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/sickness/EventEditor.vue >>> editorShownSickness get');
                    if (true === me.value) {                                    // we're opening so initialize data

                        // >>> ------------------ update
                        if (this.editorMode === 'update') {
                            if (eventRecord) {
                                Object.assign(me, {
                                    eventName       : this.eventName, // eventRecord.name,
                                    startDate       : new Date(eventRecord.startDate),
                                    endDate         : new Date(eventRecord.endDate),
                                    certificate     : eventRecord.certificate,
                                    fit             : eventRecord.fit,
                                    sickOnTour      : eventRecord.sickOnTour,
                                    sickChild       : eventRecord.sickChild,
                                    dutyComment     : eventRecord.dutyComment,
                                });
                            }
                        }

                        // >>> ------------------ create
                        if (this.editorMode === 'create') {
                            if (resourceRecord) {
                                timestamp = new Date(this.addDate).setHours(0, 0, 0, 0);
                                startDate = new Date(timestamp);
                                timestamp = new Date(this.addDate).setHours(23, 59, 0, 0);
                                endDate = new Date(timestamp);

                                Object.assign(me, {
                                    eventName       : this.eventName,
                                    startDate       : startDate,
                                    endDate         : endDate,
                                    certificate     : false,
                                    fit             : false,
                                    sickOnTour      : false,
                                    sickChild       : false,
                                    dutyComment     : null,
                                });
                            }
                        }

                    } else if (false === me.value) {                            // we're closing so fire close event
                        // this.$emit('close'); // Needed?
                    }

                    // return always Boolean
                    return !!this.value;

                }, // eo editorShownSickness get()

                /***************************************************************
                * set()
                *
                * Desc:
                * Note: only runs on close.
                *
                */
                set(value) {

                    let me = this;;


                    me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/sickness/EventEditor.vue >>> editorShownSickness set');
                    this.$emit('input', value);

                } // eo editorShownSickness set()

            } // eo function editorShownSickness()

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc: Listen to 'updatesickness'.
        * Note: Runs after the instance is created. Installs Listeners.
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/sickness/EventEditor.vue >>> created');
            eventBus.$on('updatesickness', this.onUpdate_SingleDuty); // call: modify single duty successful
            eventBus.$on('onchangedatepicker', this.onChange_DatePicker); // onChange_DatePicker (not used right now)

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/sickness/EventEditor.vue >>> beforeDestroy');
            eventBus.$off('updatesickness', this.onModifySingleDuty);
            eventBus.$off('onchangedatepicker', this.onChange_DatePicker);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_set_SelectedMultiEvents',
                'actn_create_Multiple_Duty',
                'actn_update_Multiple_Duty',
                'actn_update_SingleDuty', // Call: Modify Single Duty
                'actn_create_SingleDuty', // Call: Create Single Duty
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSave_SicknessUpdate()
            *
            * Desc:
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_SicknessUpdate: function(){

                let me = this,
                    singleParamObject = {},
                    params = {
                        breaks : []
                    };


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/sickness/EventEditor.vue >>> onSave_SicknessUpdate');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                this.employees.forEach(employee => {
                    singleParamObject = {
                        id: employee.originalId,
                        idResource: employee.resourceId,
                        from: moment(employee.startDate).format('YYYY-MM-DDT05:00:ss+0000'),
                        to: moment(employee.endDate).format('YYYY-MM-DDT21:00:ss+0000'),
                        type: 'SICKNESS',
                        status: 'PLANNED',
                        certificate     : me.certificate,
                        fit             : me.fit,
                        sickOnTour      : me.sickOnTour,
                        sickChild       : me.sickChild,
                        dutyComment: me.dutyComment !== '' ? me.dutyComment : null
                    };
                    params.breaks.push(singleParamObject);
                });


                if (this.validateParams(params) === true) {
                    this.actn_update_Multiple_Duty(params);
                }

            }, // eo function onSave_SicknessUpdate()


            /*******************************************************************
            * onSave_SicknessCreate()
            *
            * Desc:
            * Note:
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_SicknessCreate: function(){

                let me = this,
                    params = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/sickness/EventEditor.vue >>> onSave_SicknessCreate');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                params = {
                    id              : null,
                    // idResource      : this.resourceRecord.id,
                    idResources     : this.employees,
                    from            : moment(me.startDate).format('YYYY-MM-DDT05:00:ss+0000'),
                    to              : moment(me.endDate).format('YYYY-MM-DDT21:00:ss+0000'),
                    type            : 'SICKNESS',
                    status          : 'PLANNED',
                    certificate     : me.certificate,
                    fit             : me.fit,
                    sickOnTour      : me.sickOnTour,
                    sickChild       : me.sickChild,
                    split           : true,
                    dutyComment     : me.dutyComment !== '' ? me.dutyComment : null
                };

                if (this.validateParams(params) === true) {
                    // this.actn_create_SingleDuty(params);
                    this.actn_create_Multiple_Duty(params);
                    this.actn_set_SelectedMultiEvents([]); // send empty Array
                }

            }, // eo function onSave_SicknessCreate()


            /*******************************************************************
            * onClose_SicknessDialog()
            *
            * Desc: Close Sickness Dialog.
            * Note: Reset 'all selected Events' here.
            *
            */
            onClose_SicknessDialog: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/sickness/EventEditor.vue >>> onClose_SicknessDialog');
                this.actn_set_SelectedMultiEvents([]); // send empty Array, #244
                me.editorShownSickness = false;

                eventBus.$emit('schedulerdeselectall'); // #401

            }, // eo function onClose_SicknessDialog()




            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onUpdate_SingleDuty()
            *
            * Desc: Successful Call => emits 'updatesickness' Event.
            * Desc: Change Data in Scheduler.
            * Note: Using Response of call:actn_update_SingleDuty for buildEventNote
            * Note:
            *
            * @param {Object} response (Response from Call)
            */
            onUpdate_SingleDuty: function(response){

                let me = this,
                    style = null,
                    tooltipData = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/sickness/EventEditor.vue >>> onUpdate_SingleDuty');
                me.eventRecord.setStartEndDate(me.startDate, me.endDate);
                me.eventRecord.set({ certificate: me.certificate });
                me.eventRecord.set({ fit: me.fit });
                me.eventRecord.set({ sickOnTour: me.sickOnTour });
                me.eventRecord.set({ sickChild: me.sickChild });
                me.eventRecord.set({ dutyComment: me.dutyComment });


                tooltipData = me.$buildEventNote(response); // Catch after 'requested was set!: Important
                me.eventRecord.set({ nameEvent: tooltipData.nameEvent });
                me.eventRecord.set({ note: tooltipData.note });

                // >>> Style ----------------------------------------
                if (response.dutyComment !== null) {
                    if (me.eventRecord.style !== null) {
                        style = me.eventRecord.style  + ' border-right: 3px dotted #000;';
                    } else {
                        style = ' border-right: 3px dotted #000;';
                    }
                }
                me.eventRecord.set({ style: style });
                // <<< Style ----------------------------------------

                if(!me.eventRecord.eventStore) {
                    me.eventStore.add(me.eventRecord);
                    me.eventRecord.resourceId = me.resourceId;
                }


                // >>> close the editor now ...
                me.editorShownSickness = false;

            }, // eo function onUpdate_SingleDuty()


            /*******************************************************************
            * onChange_DatePicker()
            *
            * Desc: If Start DatePicker changed, it emits an Event and its
            * Desc: new Value to set it to End DatePicker.
            * Note:
            *
            * @param {String} value ()
            */
            onChange_DatePicker: function(value){

                let me = this,
                    newDate = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/sickness/EventEditor.vue >>> onChange_DatePicker');
                newDate = new Date(value);
                newDate.setHours(23);
                newDate.setMinutes(59);
                me.endDate = newDate;

            }, // eo function onChange_DatePicker()




            /*******************************************************************
            * Validators:
            *******************************************************************/
            /*******************************************************************
            * validateParams()
            *
            * Desc:
            * Note:
            *
            * @param {Object} params (Params we want to send)
            */
            validateParams: function(params) {

                let me = this,
                    startDate = null,
                    endDate = null,
                    valid = false;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/sickness/EventEditor.vue >>> validateParams');
                startDate = moment(params.from);
                endDate = moment(params.to);

                if (endDate.isBefore(startDate)) {
                    valid = false;
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Validation: EndDate must be after StartDate.'
                    });
                } else {
                    valid = true;
                }


                return valid;

            }, // eo function validateParams()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>
